import { z } from 'zod'

import { GetUserSchema } from './user'

export const OrderConfirmationSourceSchema = z.enum(['generated', 'uploaded'])

export const GetOrderConfirmationMediaSchema = z.object({
  extension: z.string(),
  file_name: z.string(),
  name: z.string(),
  size: z.number(),
})

export const GetOrderConfirmationSchema = z.object({
  created_at: z.coerce.date(),
  id: z.number(),
  load_id: z.number(),
  media: GetOrderConfirmationMediaSchema,
  source: OrderConfirmationSourceSchema,
  user: GetUserSchema,
})

export type GetOrderConfirmation = z.infer<typeof GetOrderConfirmationSchema>
export type OrderConfirmationSource = z.infer<typeof OrderConfirmationSourceSchema>
